import React from "react";
import { useTranslation } from "react-i18next";

// HEB-1: Hebrew ships. The he locale + RTL plumbing (i18n.js) were always present; this un-gates
// the switcher so users can select it. This is the single gate — no other UX-6b plumbing is
// required (i18n.js already loads `he`, persists the choice, and flips document dir to rtl).
const UI_LANGUAGES = ["en", "he"];
const LANGUAGE_LABEL_KEY = { en: "language.english", he: "language.hebrew" };

// LANG-SELECT-1 — compact is ONE box: the padding, border and 44px floor sit on the <select> itself, because the select is
// the only thing a pointer can operate. The old compact wrapper carried them instead, so the box read 47/48px while the
// select inside it — the actual target — measured 33px (en) / 34–35px (he), and a click on the wrapper's padding did nothing.
export function LanguageSwitcher({ compact = false }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = UI_LANGUAGES.includes(i18n.language) ? i18n.language : UI_LANGUAGES[0];

  return (
    <div
      className={`flex items-center ${
        compact ? "" : "gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2"
      }`}
    >
      {!compact && (
        <label
          htmlFor="language-switcher"
          className="text-[11px] font-medium uppercase tracking-wide text-slate-500"
        >
          {t("language.label")}
        </label>
      )}
      <select
        id="language-switcher"
        value={currentLanguage}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        className={`border border-slate-200 text-slate-700 outline-none transition-colors focus:border-primary/40 focus:bg-white ${
          compact ? "min-h-[44px] min-w-[7rem] rounded-xl bg-white px-2.5 text-xs" : "min-w-[8.5rem] rounded-lg bg-slate-50 px-3 py-2 text-sm"
        }`}
      >
        {UI_LANGUAGES.map((lang) => (
          <option key={lang} value={lang}>
            {t(LANGUAGE_LABEL_KEY[lang])}
          </option>
        ))}
      </select>
    </div>
  );
}
